import React from 'react';

const ProfilePreviewModal = ({ profile, onClose }) => {
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content profile-preview" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Profile Preview: {profile.business_name}</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                <div className="modal-body">
                    <section className="preview-section">
                        <h3>Basic Information</h3>
                        <div className="preview-grid">
                            <div className="preview-item">
                                <label>Business Name:</label>
                                <span>{profile.business_name}</span>
                            </div>
                            {profile.tagline && (
                                <div className="preview-item">
                                    <label>Tagline:</label>
                                    <span>{profile.tagline}</span>
                                </div>
                            )}
                            {profile.industry && (
                                <div className="preview-item">
                                    <label>Industry:</label>
                                    <span>{profile.industry}</span>
                                </div>
                            )}
                        </div>
                    </section>

                    <section className="preview-section">
                        <h3>Contact Information</h3>
                        <div className="preview-grid">
                            <div className="preview-item">
                                <label>Email:</label>
                                <span>{profile.email}</span>
                            </div>
                            {profile.phone && (
                                <div className="preview-item">
                                    <label>Phone:</label>
                                    <span>{profile.phone}</span>
                                </div>
                            )}
                            {profile.street_address && (
                                <div className="preview-item full-width">
                                    <label>Address:</label>
                                    <span>
                                        {profile.street_address}
                                        {(profile.city || profile.state || profile.zip_code) && (
                                            <><br />{[profile.city, profile.state, profile.zip_code].filter(Boolean).join(', ')}</>
                                        )}
                                        {profile.country && <><br />{profile.country}</>}
                                    </span>
                                </div>
                            )}
                        </div>
                    </section>

                    {profile.services && profile.services.length > 0 && (
                        <section className="preview-section">
                            <h3>Services ({profile.services.length})</h3>
                            <div className="services-preview">
                                {profile.services.map((service, index) => (
                                    <div key={index} className="service-preview-item">
                                        <span className="service-icon">{service.icon}</span>
                                        <div>
                                            <strong>{service.title}</strong>
                                            {service.description && <p>{service.description}</p>}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    )}

                    {profile.about_us && (
                        <section className="preview-section">
                            <h3>About Us</h3>
                            <p>{profile.about_us}</p>
                        </section>
                    )}

                    {profile.mission_statement && (
                        <section className="preview-section">
                            <h3>Mission Statement</h3>
                            <p>{profile.mission_statement}</p>
                        </section>
                    )}

                    {(profile.facebook_url || profile.twitter_url || profile.instagram_url ||
                      profile.linkedin_url || profile.youtube_url) && (
                        <section className="preview-section">
                            <h3>Social Media</h3>
                            <div className="social-links">
                                {profile.facebook_url && (
                                    <a href={profile.facebook_url} target="_blank" rel="noopener noreferrer">
                                        Facebook
                                    </a>
                                )}
                                {profile.twitter_url && (
                                    <a href={profile.twitter_url} target="_blank" rel="noopener noreferrer">
                                        Twitter
                                    </a>
                                )}
                                {profile.instagram_url && (
                                    <a href={profile.instagram_url} target="_blank" rel="noopener noreferrer">
                                        Instagram
                                    </a>
                                )}
                                {profile.linkedin_url && (
                                    <a href={profile.linkedin_url} target="_blank" rel="noopener noreferrer">
                                        LinkedIn
                                    </a>
                                )}
                                {profile.youtube_url && (
                                    <a href={profile.youtube_url} target="_blank" rel="noopener noreferrer">
                                        YouTube
                                    </a>
                                )}
                            </div>
                        </section>
                    )}
                </div>

                <div className="modal-footer">
                    <button className="btn-secondary" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProfilePreviewModal;
